import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play Scholardle" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        We have collected a list of the top academic words! Guess the academic word in 6 tries if you can...
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="T"
          status="correct"
        />
        <Cell value="A" />
        <Cell value="B" />
        <Cell value="L" />
        <Cell value="E" />
        <Cell value="S" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter T is in the word and in the correct spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="P" />
        <Cell value="R" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="O"
          status="present"
        />
        <Cell value="V" />
        <Cell value="E" />
        <Cell value="N" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter O is in the word but in the wrong spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="I" />
        <Cell value="N" />
        <Cell value="C" />
        <Cell isRevealing={true} isCompleted={true} value="U" status="absent" />
        <Cell value="R" />
        <Cell value="S" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter U is not in the word in any spot.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        This is <a href="https://writefull.com"
                   className="underline font-bold">Writefull's</a> academic twist on the open source version of the word guessing game!{' '}
        <a
          href="https://blog.writefull.com/scholardle-wordle-for-researchers/"
          className="underline font-bold"
        >
          Learn more about Scholardle here!
        </a>{' '}
      </p>
    </BaseModal>
  )
}
